import { css } from 'linaria';

export const sectionHeadTitle = css`
  color: var(--text-primary);
  font-feature-settings:
    'clig' off,
    'liga' off;
  font-size: 20px !important;
  font-style: normal;
  font-weight: 700 !important;
  line-height: 26px !important;
  text-transform: uppercase;
`;
